import React from 'react'
import {Field, FieldArray} from 'redux-form'
import Comment from '../../../../components/Comment'
import { I18n } from 'react-i18next'
import {getModule, getUserIdAndName} from '../../selectors'
import {connect} from 'react-redux'
import {TextField} from "../../../../components/Form";
import getFormValidations from "./formValidations";
// binding for redux-form

const arrayToObject = (array= []) =>
    array.reduce((obj, item) => {
        obj[item.id] = item
        return obj
    }, {})

const VisualComponent = ({
    fields: { push, getAll, remove, insert }, editable, disabled,
    placeholder, noRowsMessage, tKeyText, tKeyUser, tKeyDate, validationMessage,
    textWith, columns, module, user
}) => {
    const objects = getAll()
    const allIds = objects && objects.map(o => o.id)
    const byId = arrayToObject(objects)

    // Function to update a comment by ID
    const updateComment = (id, updates, propertiesToDelete = []) => {
        const index = objects.findIndex(obj => obj.id === id)
        if (index !== -1) {
            // Get the current object and merge with updates
            const updatedObject = { ...objects[index], ...updates }

            // Remove specified properties
            propertiesToDelete.forEach(prop => {
                delete updatedObject[prop]
            })

            // Remove the old one and insert the updated one at the same position
            remove(index)
            insert(index, updatedObject)
        }
    }

    // Function to remove a comment by ID
    const removeComment = (id) => {
        const index = objects.findIndex(obj => obj.id === id)
        if (index !== -1) {
            remove(index)
        }
    }

    return (
        <I18n ns={[module.model, 'platform']}>
            {t =>
                <Comment
                    user={user}
                    byId={byId}
                    allIds={allIds}
                    columns={columns}
                    editable={editable}
                    disabled={disabled}
                    textWith={textWith}
                    push={push}
                    update={updateComment}
                    remove={removeComment}
                    placeholder={placeholder}
                    noRowsMessage={noRowsMessage}
                    tKeyText={tKeyText}
                    tKeyUser={tKeyUser}
                    tKeyDate={tKeyDate}
                    validationMessage={validationMessage}
                    t={t}
                />
            }
        </I18n>
    )
}

const CommentField = ({ field, module, user, objectMode }) => {
    const validations = getFormValidations(field)

    return (
        <FieldArray
            name={field.path}
            placeholder={field.placeholder}
            noRowsMessage={field.noRowsMessage}
            tKeyText={field.tKeyText}
            tKeyUser={field.tKeyUser}
            tKeyDate={field.tKeyDate}
            validationMessage={field.validationMessage}
            validate={validations}
            component={VisualComponent}
            disabled={field.disabled || !field.writable}
            textWith={field.textWidth}
            editable={!field.editable ? objectMode === 'newObject' : field.editable}
            columns={field.fields}
            module={module}
            user={user}
            rerenderOnEveryChange={true}
        />
    )
}
const mapStateToProps = (state) => ({
    module: getModule(state),
    user: getUserIdAndName(state),
})


export default connect(mapStateToProps)(CommentField)
